/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:5ec878ee-3a22-451a-828f-3ad584c3dc3d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_MaDj3G3KI",
    "aws_user_pools_web_client_id": "3p7bh68oof4ai4obaa8ire1bg",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://quxsr4rt6feqxf4lygwqhl5rdi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "oiltrackerstorage232900-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
